import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a2471c7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "cards render-hide-scroll"
};
const _hoisted_2 = {
  class: "nav_select"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 1,
  class: "list"
};
const _hoisted_5 = {
  class: "card_list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "over_card"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "bottom"
};
const _hoisted_11 = {
  key: 0,
  class: "double"
};
const _hoisted_12 = {
  class: "title render-font-family"
};
const _hoisted_13 = {
  class: "bottom_op"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-reportweibo"
}), /*#__PURE__*/_createTextVNode("已默认选择卡包中符合条件的卡片,若需替换可手动调整 ")], -1));
const _hoisted_15 = {
  class: "bottom"
};
const _hoisted_16 = {
  class: "btns"
};
const _hoisted_17 = {
  class: "wrapper"
};
const _hoisted_18 = {
  class: "card"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "兑换成功", -1));
const _hoisted_20 = ["src"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "level"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "level_name"
}, "罕贵卡")], -1));
const _hoisted_22 = {
  class: "render-font-family"
};
const _hoisted_23 = {
  class: "tips"
};
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 可在 ");
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 查看兑换成功的卡牌 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_list = _resolveComponent("list");
  const _component_van_overlay = _resolveComponent("van-overlay");
  const _component_BigImage = _resolveComponent("BigImage");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['nav_status', {
      appNav: $data.env.isModianIos() || $data.env.isModianAndroid()
    }, {
      wxApp: $data.env.isWxApp()
    }])
  }, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nav, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass({
        active: $data.level_name == item.level_name
      }),
      key: index,
      onClick: _withModifiers($event => $options.changeNav(item.level_name), ["stop"])
    }, _toDisplayString(item.level_name), 11, _hoisted_3);
  }), 128))])], 2), $data.total == 0 && $data.page == 1 ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
    "immediate-check": "false",
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.card_detail_list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "list_item",
        key: index
      }, [_createElementVNode("div", {
        class: _normalizeClass(['bg', {
          active: $data.order_id_list.includes(item.card_order_id)
        }, {
          disabled: !item.can_deliver_goods
        }]),
        onClick: _withModifiers($event => $options.checkCard(item.card_order_id, item.can_deliver_goods), ["stop"])
      }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        src: `${_ctx.$imgUrlFilter(item.card_img_url, 220)}`
      }, null, 8, _hoisted_8), _createElementVNode("div", {
        class: "meng",
        onClick: _withModifiers($event => $options.showBigImage(index), ["stop"])
      }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, _toDisplayString(item.level_name), 1), item.card_back_img_url ? (_openBlock(), _createElementBlock("div", _hoisted_11, "多图")) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(['check', {
          selected: $data.order_id_list.includes(item.card_order_id)
        }, {
          disabled: !item.can_deliver_goods
        }])
      }, null, 2)])], 10, _hoisted_6), _createElementVNode("p", _hoisted_12, _toDisplayString(item.card_name), 1), _createElementVNode("span", null, "免费寄存剩 " + _toDisplayString(item.deposit_days) + "天", 1)]);
    }), 128))])]),
    _: 1
  }, 8, ["loading", "onLoad"])])), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("p", null, "已选：" + _toDisplayString($data.nowNum) + "张", 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    class: _normalizeClass(['btn', {
      no: $data.nowNum != $data.allTypeNum
    }]),
    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.open && $options.open(...args), ["stop"]))
  }, " 确认兑换 ", 2)])])]), _createVNode(_component_van_overlay, {
    show: $data.showDia,
    onClick: $options.closeDia
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
      class: "block",
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
    }, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("img", {
      src: `${_ctx.$imgUrlFilter($data.exItem.img_url, 470)}`
    }, null, 8, _hoisted_20), _hoisted_21, _createElementVNode("p", _hoisted_22, _toDisplayString($data.exItem.card_name), 1), _createElementVNode("div", {
      class: "btn",
      onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.jump && $options.jump(...args), ["stop"]))
    }, "继续兑换"), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = (...args) => $options.jumpCard && $options.jumpCard(...args))
    }, "我的卡包"), _hoisted_25])])])])]),
    _: 1
  }, 8, ["show", "onClick"]), _createVNode(_component_BigImage, {
    show: $data.bigImageVisible,
    init: $data.bigInitIndex,
    list: $data.img_list,
    onClose: _cache[5] || (_cache[5] = $event => $data.bigImageVisible = false)
  }, null, 8, ["show", "init", "list"])]));
}